import { GcpConnectionType } from "../../utils/types";

export const getGcpConnectionInitialConnectionId = (
  connectionType: GcpConnectionType,
): string => {
  const type = connectionType === "single" ? "project" : "organization";
  return `<YOUR ${type.toUpperCase()} ID>`;
};
